import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconInboxComponent } from "./med-icon-inbox.component";

@NgModule({
  declarations: [
    MedIconInboxComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconInboxComponent,
  ],
})
export class MedIconInboxModule { }
